import { FIELD } from "./constants";

// The questions are held in cdsQuestions, a TAbMemDataSet, so there is no real table behind them.
// OMTRANSACTIONHEADER is what the screen operates on and is what the Localization lookup would key
// against; every field here sets isLabelChanged so the literal Delphi caption wins regardless.
const TABLE = "OMTRANSACTIONHEADER";

/**
 * The legacy "Questions" group box (grpQuestions in uOMD0025.dfm), split across four FormField groups
 * so they render as col-md-4 columns rather than one tall stack.
 *
 * Captions are the Delphi captions verbatim, including the abbreviated "Use Predefined Acc.". Do not
 * normalise them.
 *
 * The Comment memo (grpComment / edtComment) IS carried forward, for visual parity with the legacy
 * form, but it is display-only: uOMD0025.pas never reads edtComment, SPOM_COMMIT has no parameter for
 * it, and PreCommitTransactionRequestDTO has no member for it - so buildRequest deliberately leaves it
 * out and whatever is typed here is not persisted.
 *
 * TYPES
 *  - Create Tax Liability is "select", never "text": it is a coded Y/N field and rule 3 requires a
 *    descriptive dropdown. Fields.js renders a SelectBox with NO dataSource, so the page fills it in
 *    onFormLoad via loadLookupFromStaticDataSource.
 *  - The three accounts are "select" too, fed from the shared AC Account lookup
 *    (GET ac/Lookup/GetAcAccounts) the same way every other account picker in the app is. They carry
 *    showClearButton so a picked account can be taken back out - Sales Account is legitimately blank.
 *  - Comment is "textarea", not "text" (Architecture.md rule 9).
 *
 * REQUIRED
 *  All of them are required:false, and that is load-bearing rather than laziness. Fields.js emits a
 *  STATIC RequiredRule with no conditional form, but the two accrual accounts are required only while
 *  "Use Predefined Acc." is unchecked, and Sales Account is never required at all. The conditional
 *  rule therefore lives in the page's confirmPreCommit (immediate feedback) and again in
 *  OMCommitTransactionService.ValidatePreCommitRequest, which is the authority.
 */
const QuestionsLayout = [
    {
        groupId: 4,
        fields: [
            {
                name: FIELD.Comment,
                tableName: TABLE,
                label: "Comment",
                type: "textarea",
                required: false,
                visible: true,
                isLabelChanged: true,
            }]
    },
    {
        groupId: 1,
        fields: [
            {
                name: FIELD.CreateTaxLiability,
                tableName: TABLE,
                label: "Create Tax Liability",
                type: "select",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.SalesAccountRowId,
                tableName: TABLE,
                label: "Sales Account",
                type: "select",
                showClearButton: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            }
        ],
    },
    {
        groupId: 2,
        fields: [
            {
                name: FIELD.AccruedReceivablesAccountRowId,
                tableName: TABLE,
                label: "Accrued Receivables",
                type: "select",
                showClearButton: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            }, {
                name: FIELD.UsePredefinedAccounts,
                tableName: TABLE,
                label: "Use Predefined Acc.",
                type: "checkbox",
                required: false,
                visible: true,
                isLabelChanged: true,
            }]
    },
    {
        groupId: 3,
        fields: [
            {
                name: FIELD.AccruedPayablesAccountRowId,
                tableName: TABLE,
                label: "Accrued Payables",
                type: "select",
                showClearButton: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            }]
    }
];

export { QuestionsLayout };
